export default __webpack_public_path__ + "static/slide5-63c11ce73aa039c532d67741c094ebe7.jpg";